import { render, staticRenderFns } from "./WideDoc.vue?vue&type=template&id=348ef0ba&scoped=true&"
import script from "./WideDoc.vue?vue&type=script&lang=js&"
export * from "./WideDoc.vue?vue&type=script&lang=js&"
import style0 from "./WideDoc.vue?vue&type=style&index=0&id=348ef0ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ef0ba",
  null
  
)

export default component.exports